import React, { Component } from 'react'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  ButtonAdd,
  File,
  HeadContainer,
  InputCol,
  LevelRowContainer,
  MainWrapperAttachment,
  RoundedWrapper,
} from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import { Label } from 'components/atoms/Texts/TxtLabel'
import lo from 'lodash'
import Icon from 'atoms/Icon'
import ic_add from 'App/assets/images/ic_add.png'
import ic_sheet from 'App/assets/images/ic-file-sheet.png'
import IconPng from 'components/atoms/IconPng/index'

const FILE_TYPES = {
  '.xls': ic_sheet,
  '.xlsx': ic_sheet,
}

const MAX_FILE_SIZE = 10 * 1024 * 1024

export class StockOpnameAttachmentsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachment: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (!lo.isEqual(this.props.importExcelUploadAttachments, prevProps.importExcelUploadAttachments)) {
      this.init()
    }
  }

  init() {
    this.setState({
      attachment: this.props.importExcelUploadAttachments || null,
    })
  }

  fnChange(file) {
    const { onChange } = this.props

    if (file.size > MAX_FILE_SIZE) {
      alert(`The file "${file.name}" exceeds the maximum size of 10MB.`)
      return
    }

    const reader = new FileReader()
    reader.addEventListener('load', (event) => {
      const newFile = {
        filename: file.name,
        mimeType: file.type,
        media: {
          type: 'DOCUMENT',
        },
        file: event.target.result.split(',')[1],
      }

      this.setState({ attachment: newFile }, () => {
        onChange(newFile)
      })
    })
    reader.readAsDataURL(file)
  }

  fnRemoveEvidence() {
    const { onChange } = this.props
    this.setState({ attachment: null }, () => {
      onChange(null)
    })
  }

  getExtension(filename) {
    if (filename) {
      return '.' + filename.split('.').pop()
    }
  }

  render() {
    const { theme } = this.props
    const { attachment } = this.state

    return (
      <RoundedWrapper>
        <MainWrapperAttachment>
          <HeadContainer>
            <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
              Upload Document
            </Label>
          </HeadContainer>
          <LevelRowContainer padding={'10px 10px'}>
            <InputCol>
              <Label lineheight={'14px'} size={'12px'}>
                Click to upload file
              </Label>
              <div>
                <ButtonAdd src={ic_add} onClick={() => document.getElementById('evidence').click()} />
                <input
                  id="evidence"
                  type="file"
                  accept={Object.keys(FILE_TYPES).join(',')}
                  onChange={(e) => this.fnChange(e.target.files[0])}
                  hidden
                />
                {attachment && (
                  <File>
                    <IconPng
                      srcIcon={FILE_TYPES[this.getExtension(attachment.filename)]}
                      size={'auto'}
                      h={'24'}
                      mr={'20px'}
                    />
                    <Label lineheight={'14px'} size={'12px'} mb="0">
                      {attachment.filename}
                    </Label>
                    <Icon
                      ml="auto"
                      name="times-circle"
                      color={theme.mocaRed}
                      onClick={() => this.fnRemoveEvidence()}
                      showPointer
                    />
                  </File>
                )}
              </div>
            </InputCol>
          </LevelRowContainer>
        </MainWrapperAttachment>
      </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => ({
  viewState: state.viewState,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ toggleIsLoading }, dispatch)

export default withRouter(withTheme(connect(mapStateToProps, mapDispatchToProps)(StockOpnameAttachmentsForm)))
